import { useEffect } from 'react';
import { useState } from 'react';

interface Params<T> {
    options: T[];
    isLoading: boolean;
}

export const useDeferredOptions = <T>({
    options: actualOptions,
    isLoading,
}: Params<T>): T[] => {
    const [options, setOptions] = useState(actualOptions);

    useEffect(() => {
        if (!isLoading && actualOptions !== options) {
            setOptions(actualOptions);
        }
    }, [actualOptions, options, isLoading]);

    return options;
};
